var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:_vm.icon,style:(_vm.style),attrs:{"data-cy":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }